// extracted by mini-css-extract-plugin
export default {"grid":"models-page-model_grid__xIx-T","info":"models-page-model_info__EVdf8","detail":"models-page-model_detail__0Y9f9"};